<template>
  <div class="invalid-special-rate">
    <div class="d-flex invalid-special-rate__message">
      <i class="icon rhg-font-icon--alert md color-primary"></i>
      <span class="invalid-special-rate__title">{{ label }}</span>
    </div>
    <div class="btn-custom">
      <button
        class="btn cta-btn-custom"
        :disabled="bookingDisabled"
        @click="$emit('checkAvailability', hotel)"
      >
        <span class="button__text" v-if="!loading">
          {{ translate('rdCheckAvailability') }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvalidSpecialRate',
  props: {
    label: String,
    hotel: Object
  }
}
</script>

<style lang="scss" scoped>
.btn-custom {
  margin-right: auto;
  display: flex;
  justify-content: flex-end;

  .cta-btn-custom {
    padding: 1.6rem 2.4rem;
    line-height: 2rem;
    height: 48px;
    width: 221px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    border-radius: 48px;
    background-color: #c62525;
    span {
      color: #ffffff;
    }
  }
  .button__text {
    font-style: normal;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 22px;
    text-align: center;
    text-transform: uppercase;
    color: #c62525;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
}
.invalid-special-rate {
  display: flex;
  padding: 2.5rem;
  background-color: #fcf0f1;

  &__message {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    gap: 1.6rem;
  }

  &__title {
    font-weight: bold;
    font-size: 16px;
    margin-top: 1rem;
  }

  &__description {
    font-size: 12px;
  }
}
@media (max-width: 920px) {
  .invalid-special-rate {
    flex-direction: column;

    &__title {
      margin-top: 0;
    }
  }
  .btn-custom {
    padding-left: 0px;
    margin-top: 1rem;
    margin-left: auto;
    margin-right: auto;
    .cta-btn-custom {
      margin-left: 0;
    }
  }
}
</style>
